$(document).on('change', '[data-submit]', function(e) {
  var form;
  form = $(this).closest('form');
  if (form.attr('method') === 'get') {
    return Turbo.visit((form.attr('action')) + "?" + (form.serialize()), {
      action: 'replace'
    });
  } else {
    return form.submit();
  }
});
